import CloseIcon from '@mui/icons-material/Close';
import { DialogActions, DialogContent, Grid } from '@mui/material';
import { RefObject } from 'react';
import Cropper, { ReactCropperElement } from 'react-cropper';
import { ChatBoxHeader, WsButton, WsDialog, WsTypoVariants, WsTypography } from 'wisestep-base';

export interface IComponentProps {
  openDialog: boolean;
  handleClose: () => void;
  onSave: () => void;
  cropperRef: RefObject<ReactCropperElement>;
  image: any;
}

const LogoPreviewModal = ({
  openDialog,
  handleClose,
  onSave,
  cropperRef,
  image,
}: IComponentProps) => {
  return (
    <WsDialog size="medium" openDialog={openDialog}>
      <ChatBoxHeader>
        <WsTypography variant={WsTypoVariants.SUB_TITLE} display="inline" bold={true}>
          Uploaded Logo:
        </WsTypography>
        <CloseIcon
          sx={{ cursor: 'pointer', float: 'right', mt: 0.5 }}
          fontSize={'small'}
          onClick={handleClose}
        />
      </ChatBoxHeader>
      <DialogContent>
        <Grid container>
          <Grid item p={1} sm={12}>
            {image && (
              <Cropper
                ref={cropperRef}
                style={{
                  height: 400,
                  width: '100%',
                  border: '1px solid black',
                  borderRadius: '2px',
                }}
                zoomTo={0.5}
                initialAspectRatio={1}
                preview=".img-preview"
                src={image}
                viewMode={1}
                minCropBoxHeight={10}
                minCropBoxWidth={10}
                background={false}
                responsive={true}
                autoCropArea={1}
                checkOrientation={false}
                guides={true}
              />
            )}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <WsButton variant="outlined" onClick={handleClose}>
          Close
        </WsButton>
        <WsButton variant="contained" size="medium" type="submit" onClick={onSave}>
          Next
        </WsButton>
      </DialogActions>
    </WsDialog>
  );
};

export default LogoPreviewModal;
